import gql from "graphql-tag";
import { Employee } from "../baseTypes";
export default gql`
  query SearchEmployees(
    $filter: SearchableEmployeeFilterInput
    $from: Int
    $limit: Int
    $search: String
  ) {
    searchEmployees(
      filter: $filter
      from: $from
      limit: $limit
      search: $search
      sort: { field: insuranceNumber, direction: asc }
    ) {
      total
      items {
        birthdate
        identifier
        insuranceNumber
        locationId
        expiresAt
        address {
          street
          city
          zip
          number
        }
        location {
          id
          name
        }
        patient {
          email
          insuranceNumber
          firstname
          lastname
        }
      }
    }
  }
`;
export interface SearchEmployeesQuery {
  searchEmployees: {
    items: Array<Employee> | null;
    total?: number;
  };
}
